export default function alpha() {
  document.getElementsByTagName('body')[0].style.backgroundColor = '#b3ffb3';
}

